import { cn } from "@/lib/utils";
import {
  pictureDimensions,
  pictureImgSrc,
  pictureSourceEntries,
  type MarketingPicture,
} from "@/lib/marketing-images";

type MarketingHeroImageProps = {
  picture: MarketingPicture;
  alt: string;
  sizes: string;
  className?: string;
  /** Use high priority for the page LCP hero. */
  priority?: boolean;
  loading?: "eager" | "lazy";
};

export function MarketingHeroImage({
  picture,
  alt,
  sizes,
  className,
  priority = false,
  loading,
}: MarketingHeroImageProps) {
  const dims = pictureDimensions(picture);
  const resolvedLoading = loading ?? (priority ? "eager" : "lazy");

  return (
    <picture>
      {pictureSourceEntries(picture).map((source) => (
        <source key={source.type} type={source.type} srcSet={source.srcSet} sizes={sizes} />
      ))}
      <img
        src={pictureImgSrc(picture)}
        alt={alt}
        sizes={sizes}
        className={cn(className)}
        decoding="async"
        loading={resolvedLoading}
        {...(priority ? { fetchPriority: "high" as const } : {})}
        {...dims}
      />
    </picture>
  );
}
